import React from 'react';
import { LinearProgress } from '@mui/material';
import { useSupplementsList } from '../../../contextsProperty/ContextSupplements';
import SupplementCard from './SupplementCard';
import useTranslate from '../../../../customHooks/useTranslate';
import Card from '../../../../muiComponents/Card';

const SupplementsCards = () => {
    const { items, isLoading, handleScroll } = useSupplementsList();
    const translate = useTranslate();

    return (
        <div className='flex-column flex-grow min-height-0'>
            <div
                className=' flex-grow flex-column gap-20 min-height-0 overflow-y-auto overflow-x-hidden'
                onScroll={handleScroll}
            >
                {items.map(item => (
                    <SupplementCard key={item.Id} supplement={item} />
                ))}
                <Card className='padding20 flex-column gap-20'>
                    {items.length === 0 && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default SupplementsCards;
